module.exports = __webpack_public_path__ + "img/universkin-m-active-icon.64bad1e4.svg";